import { GET_WALLET_BALANCE, GET_WALLET_BALANCE_ERROR, GET_WALLET_BALANCE_REQUEST, UPDATE_WALLET_BALANCE_DATA, REMOVE_WALLET_BALANCE_DATA } from "../ActionTypes/ActionTypes.js";

const initialState = {
    walletBalanceLoading: false,
    walletBalanceData: null,
    walletBalanceError: null,
    walletBalanceStatus: null,
    isModified: false,
    isFirstLoad: true,
    spotBalance: null,
    fundBalance: null


};

const walletBalanceReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_WALLET_BALANCE_REQUEST:
            return { ...state, walletBalanceLoading: state.isFirstLoad, walletBalanceStatus: null, walletBalanceData: null };
        case GET_WALLET_BALANCE:
            return {
                walletBalanceLoading: false, walletBalanceData: action.payload, walletBalanceError: null, walletBalanceStatus: true,
                isFirstLoad: false, spotBalance: action?.payload?.result?.spot, fundBalance: action?.payload?.result?.fund
            };

        case GET_WALLET_BALANCE_ERROR:
            return { walletBalanceLoading: false, walletBalanceData: null, walletBalanceError: action?.payload, walletBalanceStatus: false, isFirstLoad: false, };
        case UPDATE_WALLET_BALANCE_DATA:
            return {
                ...state,
                walletBalanceData: {
                    ...state.walletBalanceData,
                    result: {
                        ...state.walletBalanceData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_WALLET_BALANCE_DATA:
            return { ...state, walletBalanceData: null, walletBalanceError: null, isModified: false, walletBalanceStatus: null, isFirstLoad: true, walletBalanceLoading: false }
        default:
            return state;
    }
};

export default walletBalanceReducer;